<template>
  <div id="play">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('index.videos') }}
      </div>
    </div>
    <video
      id="my-video"
      class="video-js vjs-default-skin"
      controls
      preload="auto"
      style="width:100%;height: 250px;"
    >
      <source :src="data.url">
    </video>
  </div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"

import { NoticeBar } from 'vant';
Vue.use(NoticeBar);
	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field
	} from "vant";

	Vue.use(Icon).use(Progress).use(Dialog).use(Field);

	export default {
		name: "Video",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				data: {url:'https://www.fspy888.live/static/mp3/video.mp4'},
			};
		}
	};
</script>
<style lang="less" scoped>
    .red_top_bg{
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
    }
	
	.wrap_box{
		
		margin-top: 12px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.item{
			height: 50px;
			width: 95%;
			padding: 16px 0;
			border-bottom: 1px solid #ececec;
			font-size: 14px;
			color: rgba(0,0,0,.8);
			font-weight: 700;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
		}
	}

	/* Standalone video route keeps a compact, scoped black-gold player shell. */
	#play { min-height: 100vh; padding-top: 54px; background: linear-gradient(160deg, #25100c, #120907 64%, #1b0b09); }
	.red_top_bg { height: 54px; background: rgba(27, 16, 13, .97); border-bottom: 1px solid rgba(185, 135, 59, .38); }
	.red_top_bg .big_tit, .red_top_bg .back_left { color: #eec97e; }
	#my-video { display: block; height: auto !important; min-height: 220px; margin: 16px 14px; width: calc(100% - 28px) !important; border: 1px solid rgba(185, 135, 59, .46); border-radius: 14px; background: #080403; box-shadow: 0 14px 28px rgba(0, 0, 0, .32); }
</style>
